import { SyncManager } from 'db';
import { useField } from 'react-final-form';

export const useSaveNotes = (sectionId: string, vehicleId: number) => {
  const {
    input: { value: serverId }
  } = useField(`${sectionId}.id`);

  const save = async (notes: string | null, fieldName = 'notes') => {
    if (!vehicleId) return;

    const syncManager = SyncManager.getInstance(vehicleId);
    await syncManager.queueEntityUpdate(serverId, 'section', [fieldName, notes]);
  };

  return save;
};
